export default "__VITE_ASSET__F9$_rP5R__"